// @ts-nocheck
import {useNavigate} from "react-router-dom";
import {SectionHeader} from "@/components";
import EGameImg from "../../../../../assets/images/egames-section/egame-background.webp";
// Hover logos
import LogoCodHover from "../../../../../assets/images/egames-section/egames-hover/logo-cod.svg";
import LogoCSHover from "../../../../../assets/images/egames-section/egames-hover/logo-counter-strike.svg";
import LogoCsgoHover from "../../../../../assets/images/egames-section/egames-hover/logo-csgo.svg";
import LogoDota2Hover from "../../../../../assets/images/egames-section/egames-hover/logo-dota2.svg";
import LogoFifaHover from "../../../../../assets/images/egames-section/egames-hover/logo-fifa.svg";
import LogoFortniteHover from "../../../../../assets/images/egames-section/egames-hover/logo-fortnite.svg";
import LogoLolHover from "../../../../../assets/images/egames-section/egames-hover/logo-lol.svg";
import LogoOverwatchHover from "../../../../../assets/images/egames-section/egames-hover/logo-overwatch.svg";
// Default logos
import LogoCod from "../../../../../assets/images/egames-section/logo-cod.svg";
import LogoCS from "../../../../../assets/images/egames-section/logo-counter-strike.svg";
import LogoCsgo from "../../../../../assets/images/egames-section/logo-csgo.svg";
import LogoDota2 from "../../../../../assets/images/egames-section/logo-dota2.svg";
import LogoFifa from "../../../../../assets/images/egames-section/logo-fifa.svg";
import LogoFortnite from "../../../../../assets/images/egames-section/logo-fortnite.svg";
import LogoLol from "../../../../../assets/images/egames-section/logo-lol.svg";
import LogoOverwatch from "../../../../../assets/images/egames-section/logo-overwatch.svg";
import HorsesBg from "../../../../../assets/images/hipismo-section/horses-background.png";
import {useAuthStore} from "../../../../../store/useAuth.store";

const egamehomeSectionCls =
  "section-bleed relative overflow-hidden flex flex-col items-center justify-start gap-0 pt-8 pb-10 box-border max-[900px]:py-8 max-[900px]:px-0";
const egamehomeBgCls = "absolute inset-0 w-full h-full object-cover object-center z-0";
const egamehomeOverlayCls =
  "absolute inset-0 z-[var(--z-base)] bg-[linear-gradient(180deg,rgba(0,0,0,0.45)_0%,rgba(0,0,0,0.25)_50%,rgba(0,0,0,0.55)_100%)]";
const egamehomeHeaderWrapCls = "relative z-[2] w-full px-[clamp(24px,4vw,72px)] pt-6 pb-4 box-border";
const egamehomeBodyCls =
  "relative z-[2] flex flex-row items-center justify-center gap-[38px] w-full px-[clamp(32px,5vw,80px)] box-border max-[900px]:flex-col max-[900px]:gap-5 max-[900px]:px-4";
const egamehomeLeftCls =
  "flex items-center justify-center flex-shrink-0 w-[483px] h-[303px] rounded-[var(--radius-md)] overflow-hidden relative shadow-[var(--shadow-md)] max-[900px]:w-full max-[900px]:max-w-[var(--size-80)] max-[900px]:h-[var(--size-50)]";
const egamehomeCharacterCls = "w-full h-full object-cover block opacity-100";
const egamehomeCharOverlayCls =
  "absolute inset-0 flex flex-col items-center justify-center gap-3 z-[var(--z-base)] bg-[linear-gradient(180deg,rgba(0,0,0,0.15)_0%,rgba(0,0,0,0.55)_100%)]";
const egamehomeCharTitleCls =
  "font-[var(--font-family-display)] font-extrabold text-(length:--font-display) leading-[1.05] tracking-tight text-[var(--color-text)] [text-shadow:0_2px_12px_rgba(0,0,0,0.7),0_0_22px_rgba(253,238,51,0.18)] whitespace-nowrap relative after:content-[''] after:absolute after:left-1/2 after:-translate-x-1/2 after:-bottom-2 after:h-[3px] after:w-[var(--space-12)] after:rounded-full after:bg-[linear-gradient(90deg,var(--color-primary)_0%,var(--color-accent-orange-bright)_55%,var(--color-accent-magenta)_100%)] after:shadow-[0_0_18px_rgba(253,238,51,0.55)] max-[900px]:text-(length:--font-h1)";
const egamehomeCharBtnCls =
  "inline-flex items-center justify-center gap-2 h-12 px-6 mt-4 rounded-[var(--radius-pill)] border-0 cursor-pointer bg-[linear-gradient(135deg,var(--color-primary)_0%,var(--color-primary-hover)_100%)] font-[var(--font-family)] font-bold text-(length:--font-body-lg) text-[var(--color-text-inverse)] box-border shadow-[0_8px_24px_-8px_rgba(253,238,51,0.55),inset_0_1px_0_rgba(255,255,255,0.45)] transition-[transform,box-shadow,filter] duration-[var(--transition-fast)] hover:brightness-105 hover:-translate-y-0.5 hover:shadow-[0_12px_30px_-8px_rgba(253,238,51,0.7),inset_0_1px_0_rgba(255,255,255,0.5)] active:translate-y-0 active:scale-[0.98]";
const egamehomeRightCls = "flex flex-col gap-5 items-center";
const egamehomeRowCls =
  "flex flex-row items-center justify-center gap-[clamp(24px,4vw,56px)] max-[900px]:flex-wrap max-[900px]:gap-4";
const egamehomeLogoCardCls =
  "group cursor-pointer rounded-[var(--radius-lg)] relative flex items-center justify-center transition-[filter,transform] duration-300 [&>img]:block [&>img]:h-[var(--size-15)] [&>img]:max-w-[160px] [&>img]:object-contain [&>img]:transition-[filter] [&>img]:duration-300 hover:-translate-y-[3px] hover:[&>img]:[filter:drop-shadow(0_0_8px_var(--color-hipismo))_drop-shadow(0_0_20px_rgba(255,193,33,0.7))_brightness(1.08)] max-[900px]:[&>img]:h-20 max-[900px]:[&>img]:max-w-[var(--size-25)]";
const egamehomeLogoDefaultCls = "opacity-100 transition-opacity duration-300 group-hover:opacity-0";
const egamehomeLogoHoverCls =
  "absolute inset-0 w-full h-full object-contain opacity-0 transition-opacity duration-300 group-hover:opacity-100";
const egamehomeLogoFlareCls =
  "pointer-events-none absolute inset-0 opacity-0 [mask-size:contain] [mask-repeat:no-repeat] [mask-position:center] [-webkit-mask-size:contain] [-webkit-mask-repeat:no-repeat] [-webkit-mask-position:center] [mix-blend-mode:screen] group-hover:animate-[hipismo-sweep_0.9s_ease-out]";
const egamehomeLogoFlareStyle = {
  backgroundImage:
    "linear-gradient(115deg, transparent 30%, rgba(255,255,255,0.3) 42%, rgba(255,255,255,1) 50%, rgba(253,238,51,0.85) 56%, transparent 68%)",
  backgroundSize: "220% 100%",
  backgroundPosition: "180% 50%",
  backgroundRepeat: "no-repeat",
} as React.CSSProperties;

const row1 = [
  {id: "fifa", src: LogoFifa, hover: LogoFifaHover, alt: "FIFA"},
  {
    id: "counter-strike",
    src: LogoCS,
    hover: LogoCSHover,
    alt: "Counter-Strike",
  },
  {
    id: "fortnite",
    src: LogoFortnite,
    hover: LogoFortniteHover,
    alt: "Fortnite",
  },
];

const row2 = [
  {id: "lol", src: LogoLol, hover: LogoLolHover, alt: "League of Legends"},
  {id: "csgo", src: LogoCsgo, hover: LogoCsgoHover, alt: "CS:GO"},
  {id: "cod", src: LogoCod, hover: LogoCodHover, alt: "Call of Duty"},
  {id: "dota2", src: LogoDota2, hover: LogoDota2Hover, alt: "Dota 2"},
  {
    id: "overwatch",
    src: LogoOverwatch,
    hover: LogoOverwatchHover,
    alt: "Overwatch",
  },
];

const EGamesDisplay = () => {
  const navigate = useNavigate();
  const authStatus = useAuthStore(state => state.authStatus);
  const handleShowAuthModal = useAuthStore(state => state.handleShowAuthModal);

  return (
    <div className={egamehomeSectionCls}>
      <img
        src={HorsesBg}
        alt="E-Games background"
        className={egamehomeBgCls}
      />
      <div className={egamehomeOverlayCls} />

      <div className={egamehomeHeaderWrapCls}>
        <SectionHeader
          eyebrow="E-Sports"
          title="Ligas donde no sudan la camiseta, sudan los dedos"
          highlight="sudan los dedos"
          align="center"
          variant="hero"
        />
      </div>

      <div className={egamehomeBodyCls}>
        {/* Left: character image */}
        <div className={egamehomeLeftCls}>
          <img
            src={EGameImg}
            alt="E-Games character"
            className={egamehomeCharacterCls}
          />
          <div className={egamehomeCharOverlayCls}>
            <span className={egamehomeCharTitleCls}>E-games</span>
            <button
              className={egamehomeCharBtnCls}
              type="button"
              onClick={() =>
                authStatus === "authenticated" ? navigate("/games/pragmatic/vplobby") : handleShowAuthModal()
              }
            >
              Ir a todos
            </button>
          </div>
        </div>

        {/* Right: logo grid */}
        <div className={egamehomeRightCls}>
          <div className={egamehomeRowCls}>
            {row1.map(logo => (
              <div
                key={logo.id}
                className={egamehomeLogoCardCls}
                onClick={() =>
                  authStatus === "authenticated" ? navigate("/games/pragmatic/vplobby") : handleShowAuthModal()
                }
              >
                <img
                  src={logo.src}
                  alt={logo.alt}
                  className={egamehomeLogoDefaultCls}
                />
                <img
                  src={logo.hover}
                  alt={`${logo.alt} hover`}
                  className={egamehomeLogoHoverCls}
                />
                <span
                  aria-hidden="true"
                  className={egamehomeLogoFlareCls}
                  style={{
                    ...egamehomeLogoFlareStyle,
                    maskImage: `url(${logo.hover})`,
                    WebkitMaskImage: `url(${logo.hover})`,
                  }}
                />
              </div>
            ))}
          </div>
          <div className={egamehomeRowCls}>
            {row2.map(logo => (
              <div
                key={logo.id}
                className={egamehomeLogoCardCls}
                onClick={() =>
                  authStatus === "authenticated" ? navigate("/games/pragmatic/vplobby") : handleShowAuthModal()
                }
              >
                <img
                  src={logo.src}
                  alt={logo.alt}
                  className={egamehomeLogoDefaultCls}
                />
                <img
                  src={logo.hover}
                  alt={`${logo.alt} hover`}
                  className={egamehomeLogoHoverCls}
                />
                <span
                  aria-hidden="true"
                  className={egamehomeLogoFlareCls}
                  style={{
                    ...egamehomeLogoFlareStyle,
                    maskImage: `url(${logo.hover})`,
                    WebkitMaskImage: `url(${logo.hover})`,
                  }}
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default EGamesDisplay;
